import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipLevelsCreateView } from './create/create';

export const MembershipLevelsView = angular
  .module('acme.view.application.membership.levels', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.membership.levels.sidebar.controllers',
    'acme.view.application.membership.levels.controllers',
    MembershipLevelsCreateView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.levels',
      url: '/levels',
      views: {
        'subview-main': {
          controller: 'MembershipLevelsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/levels/levels.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Levels',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_CATEGORY_VIEW'],
      },
    });
  }).name;
